import { render } from "./UserPlayArchive.vue?vue&type=template&id=0a0867c5&scoped=true"
import script from "./UserPlayArchive.vue?vue&type=script&lang=js"
export * from "./UserPlayArchive.vue?vue&type=script&lang=js"

import "./UserPlayArchive.vue?vue&type=style&index=0&id=0a0867c5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0867c5"]])

export default __exports__